import objectToQuerystring from '@/utils/sfaas_temp/objectToQueryString';
import client from '@/api/client';
import { BASE_URL } from '@/constants';

import moment from 'moment';

export default {
	postSearchSelectList: param => {
		return client
			.get(`${BASE_URL}/comm/common/custCode/v1/pcIdxNumCustCodeLists`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	// custom 코드조회
	async getCommCodeDetails(codeType) {
		try {
			const params = { commCdType: codeType, sqlId: 'customPrCorSql', commCd: '', refCd: '' };
			const queryString =
				'?' +
				Object.entries(params)
					.map(([key, val]) => (!_.isNil(val) ? `${key}=${val}` : ''))
					.filter(r => r)
					.join('&');

			const response = await client.get(`${BASE_URL}/comm/common/custCode/v1/custCodeLists` + queryString);
			return response?.data;
		} catch (error) {
			throw error.response?.data;
		}
	},
	getSaleList: ({ searchParams }) => {
		let queryStr = '';
		const idxScn = 'M12';
		let stdYy = searchParams.searchDate;
		if (searchParams.searchDate !== undefined) {
			queryStr = objectToQuerystring({
				partType: searchParams.partType, //부품유형
				carScn: searchParams.carScn, //차량구분
				pacScn: searchParams.pacScn, //승상구분
				customPrCor: searchParams.customPrCor, //생산법인
				plntCd: searchParams.plntCd, //생산공장
				flclSpc: searchParams.flclSpc, //연료전지사양
				saleNat: searchParams.saleNat, //판매국가
				occuRegn: searchParams.occuRegn, //판매지역
				carTypeNm: searchParams.carTypeNm, //차종유형
				srchScn: searchParams.srchScn //조회구분
			});
		}
		return client
			.get(`${BASE_URL}/mqy/clma/pcldxNum/v1/pcldxNums/idxScn/${idxScn}/stdYy/${stdYy}` + queryStr)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	}
};
